import { gql } from '../../__generated__/gql'

export const THEMES_LIST_QUERY = gql(`
  query themes($orderBy: SortSongsEnum) {
    themes(orderBy: $orderBy) {
      id
      name
      songsCount
    }
  }
`)
